<template>
  <div id="ComponentList" class="page message-list-page">
    <!-- 文件 -->
    <div class="header-container">
      <img src="@/assets/img/member.png" class="logo-img"/>
      <page-title page-name="成员" :showTabs="false"/>
    </div>
    <div class="content-container">
      <div class="flex-1">
        <gjw-list-page-layout>
          <!-- 批量操作 -->
          <template #btnBox>
            <div>
              <el-tooltip v-if="getUserPermission" class="item" effect="dark" content="仅空间所有者支持操作" placement="top">
                <el-button type="primary" :disabled="getUserPermission">邀请成员</el-button>
              </el-tooltip>
              <el-button v-else type="primary" :disabled="getUserPermission" @click="InviteLinkDialogVisible = true">邀请成员</el-button>
            </div>
            <div>
              <span class="span-data-total">共 {{ dataTotal }} 个内容</span>
              <el-button
                type="text"
                icon="el-icon-refresh-right"
                title="刷新"
                class="refresh-btn"
                @click="handleRefresh"
              />
            </div>
          </template>
          <template #tableBox>
            <gjw-table
              ref="listTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :list-data="tableData"
              :has-page="false"
            >
              <template #userNameSlot="{ row }">
                <span class="table-name">
                  <img class="user-img" src="~@/assets/img/default-avstar.png" style="margin-right: 6px;">
                  <span>{{ row.userName }}</span>
                </span>
              </template>
              <template #permissionTypeLabelSlot>
                <div>
                  <span style="margin-right: 3px;">权限</span>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      可使用：仅可查看及下载、使用，不可修改云端文件内容（例如：上传、更新、重命名、移动等）
                      <br/>
                      可编辑：除修改权限外不限制操作
                    </div>
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </div>
              </template>
              <template #permissionTypeSlot="{ row }">
                <div v-if="row.memberType !== 'CREATOR'">
                  <el-tooltip v-if="getUserPermission" class="item" effect="dark" content="仅空间所有者支持操作" placement="top">
                    <el-radio-group v-model="row.permissionType" :disabled="getUserPermission">
                      <el-radio label="USABLE">可使用</el-radio>
                      <el-radio label="EDITABLE">可编辑</el-radio>
                    </el-radio-group>
                  </el-tooltip>
                  <el-radio-group v-else v-model="row.permissionType" :disabled="getUserPermission" @change="toggleVisibility($event, row, true)">
                    <!-- 可使用 -->
                    <el-popover
                      placement="top"
                      width="200"
                      trigger="manual"
                      v-model="row.usableVisible">
                      <div>
                        <i class="el-icon-warning" style="color: #FAAD14; margin-bottom: 15px; margin-right: 5px;"></i>
                        <span>是否确认修改权限？</span>
                      </div>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" @click="toggleVisibility(row.permissionType, row, false)">取消</el-button>
                        <el-button type="primary" size="mini" @click="handleModifyPermissionType(row.permissionType, row)">确定</el-button>
                      </div>
                      <el-radio slot="reference" label="USABLE">可使用</el-radio>
                    </el-popover>
                    <!-- 可编辑 -->
                    <el-popover
                      placement="top"
                      width="200"
                      trigger="manual"
                      v-model="row.editadleVisible">
                      <div>
                        <i class="el-icon-warning" style="color: #FAAD14; margin-bottom: 15px; margin-right: 5px;"></i>
                        <span>是否确认修改权限？</span>
                      </div>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" @click="toggleVisibility(row.permissionType, row, false)">取消</el-button>
                        <el-button type="primary" size="mini" @click="handleModifyPermissionType(row.permissionType, row)">确定</el-button>
                      </div>
                      <el-radio slot="reference" label="EDITABLE">可编辑</el-radio>
                    </el-popover>
                  </el-radio-group>
                </div>
                <span v-else>所有者</span>
              </template>
              <template #operateSlot="{ row }">
                <el-tooltip v-if="row.memberType !== 'CREATOR' && getUserPermission" class="item" effect="dark" content="仅空间所有者支持操作" placement="top">
                  <span class="delete-text-disabled">移除</span>
                </el-tooltip>
                <span v-if="row.memberType !== 'CREATOR' && !getUserPermission" class="delete-text" @click="handleRemove(row)">移除</span>
              </template>
            </gjw-table>
          </template>
        </gjw-list-page-layout>
      </div>
    </div>

    <invite-link-dialog :dialog-visible="InviteLinkDialogVisible" title="通过链接邀请成员" isNeedInvitationLink @close="InviteLinkDialogVisible = false"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listErrorCodeMap, removeErrorCodeMap, modifyErrorCodeMap } from './errorCodeMap'
import PageTitle from '@/components/business/PageTitle.vue'
import InviteLinkDialog from './components/InviteLinkDialog'

export default {
  name: 'Member',
  components: {
    PageTitle,
    InviteLinkDialog
  },
  data() {
    return {
      userPermissionType: '',
      tableData: [],
      tableLoading: false,
      dataTotal: 0,
      spaceId: this.$route.params.spaceId,
      InviteLinkDialogVisible: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
    tableColumns() {
      const allCols = [
        {
          type: 'slot',
          slotName: 'userNameSlot',
          label: '用户',
          prop: 'userName',
          minWidth: '160px',
        },
        {
          label: '手机号',
          prop: 'mobile',
          minWidth: '160px',
        },
        {
          label: '加入空间时间',
          prop: 'createTime',
          minWidth: '160px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY年MM月DD日 HH:mm')
          },
        },
        {
          type: 'slot',
          slotName: 'permissionTypeSlot',
          labelSlotName: 'permissionTypeLabelSlot',
          label: '权限',
          prop: 'permissionType',
          minWidth: '200px'
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          minWidth: '80px'
        },
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    },
    getUserPermission() {
      return this.userPermissionType !== 'CREATOR'
    }
  },
  created() {
    // 获取空间ID
    this.init()
  },
  methods: {
    async init() {
      await this.getList()
      this.userPermissionType = this.tableData.find((item) => item.userId === this.user.id)?.permissionType
    },
    // 获取列表数据
    async getList() {
      this.tableLoading = true
      await this.$api.member.getMemberList(this.spaceId).then((data) => {
        this.tableData = data.list
        this.dataTotal = data.totalCount
      }).catch((err) => {
        this.$matchError(err.code, listErrorCodeMap)
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 移除
    async handleRemove(row) {
      try {
        this.$confirm(`是否确认移除 ${row.userName} ？<span style="color:#999;">移除后该成员将无法继续访问本空间，但其在本空间内的操作仍保留，该操作无法撤回。</span>`,
          {
            type: 'warning',
            dangerouslyUseHTMLString: true,
            confirmButtonClass: 'user-confirm',
            confirmButtonText: '确定删除'
          }).then(async () => {
          this.$api.member.removeMember(this.spaceId, row.userIdStr).then((res) => {
            this.$fullLoading.close()
            this.$message.success('移除成功')
            this.$tracks({ event: 'moveMember', params: { g_c_space_id: this.spaceId }})
            this.getList()
          }).catch((err) => {
            this.$matchError(err.code, removeErrorCodeMap)
          }).finally(() => {
            this.$fullLoading.close()
          })
        }).catch(() => { })
      } finally {
        this.$fullLoading.close()
      }
    },
    // 刷新
    async handleRefresh() {
      await this.getList()
      this.$message.success('刷新成功')
    },
    toggleVisibility(val, row, status) {
      if (val === 'USABLE') {
        this.$set(row, 'usableVisible', status)
        !status && (row.permissionType = 'EDITABLE')
      } else if (val === 'EDITABLE') {
        this.$set(row, 'editadleVisible', status)
        !status && (row.permissionType = 'USABLE')
      }
    },
    // 修改成员权限
    async handleModifyPermissionType(val, row) {
      try {
        await this.$api.member.modifyPermission(this.spaceId, row.userIdStr, { permission_type: val })
        this.$message.success('设置成功')
        this.$tracks({ event: 'modifyMemberPermission', params: { g_c_space_id: this.spaceId }})
        this.getList()
      } catch (err) {
        this.getList()
        this.$matchError(err.code, modifyErrorCodeMap, '设置失败')
      } finally {
        row.usableVisible = false
        row.editadleVisible = false
      }
    }
  },
}
</script>

<style lang="less" scoped>
.header-container {
  display: flex;
  align-items: center;
  >div:first-child {
    display: flex;
    align-items: center;
  }
  .logo-img {
    width: 18px;
    height: 21px;
    margin: 0 -16px 0 16px;
  }
}

.flex-1 {
  height: calc(100vh - 90px);
}

.delete-text {
  color: red;
  cursor: pointer;
}

.delete-text-disabled {
  cursor: not-allowed;
  color: #bfbfbf;
}

.component-uploader {
  position: fixed;
  bottom: 0;
  z-index: 999;
}

.table-name {
  img {
    position: relative;
    top: 5px;
  }
}
.user-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

/deep/ .right-part {
  width: 1px;
  height: calc(100vh - 100px);
}

/deep/ .el-table .el-table__body-wrapper {
  max-height: calc(100% - 51px);
}

.el-radio {
  margin-right: 30px;
  /deep/ .el-radio__label {
    font-size: 12px;
  }
}
.span-data-total {
  font-size: 12px;
  color: rgba(73, 95, 112, 0.6);
}
</style>

<style>
.el-message-box .el-message-box__btns .user-confirm {
  color: #ff4d4f;
  width: 88px;
  height: 32px;
  border: 1px solid #ff4d4f;
  border-radius: 2px;
  background: #ffffff;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.016);
}
</style>
